import { API } from '../index';

import { constants } from '../../Configs/constants';

const {
  endpoints: {
    LOGIN,
    LOGOUT,
    CREATE,
    VERIFY,
    RESET,
    REFRESH,
    UPDATE_USER,
    UPDATE_AVATAR,
    GET_BROKERS,
    DELETE_USER,
  },
} = constants;

export const login = async body => await API.post(LOGIN, body);

export const create = async (config, body) =>
  await API.post(CREATE, body, config);

export const createAdmin = async (config, body) =>
  await API.post(CREATE + '/admin', body, config);

export const logout = async config => await API.post(LOGOUT, {}, config);

export const verify = async token => await API.post(VERIFY + '/' + token);

export const reset = async (config, { body, id }) =>
  await API.patch(RESET + '/' + id, body, config);

export const refresh = async config => await API.post(REFRESH, {}, config);

export const updateUser = async (config, { body, id }) =>
  await API.patch(UPDATE_USER + '/' + id, body, config);

export const updateAvatar = async (config, { body, id }) => {
  return await API.patch(UPDATE_AVATAR + '/' + id, body, config);
};

export const getUsers = async () => {
  return await API(GET_BROKERS);
};

export const getUser = async (config, id) => {
  return await API(GET_BROKERS + '/' + id, config);
};

export const deleteUser = async (config, id) => {
  return await API.delete(DELETE_USER + '/' + id, config);
};
